import React, { useState } from 'react'
import qs from 'qs'
import classNames from 'classnames'
import util from 'meinian-package/src/utils/util'
import { PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import ImageDetail from 'view/detail/imageDetail'
import { ossImg } from 'meinian-package/src/utils/image'
import { getPlatformConfig, CONFIG_KEY } from 'view/detail/imageDetail/infoView/info/originalText/config'
import { hasFromData } from 'view/detail/imageDetail/infoView/info/originalText'
import { Layer } from '../image.base'
import { BatchItem } from '../../../batch'
import { TITLE_CONFIG, TITLE_INS_CONFIG, isFun } from './config'
import { StyleStateLabel } from '../styleInfo'

const Image = (props) => {
  const {
    total,
    data = [],
    isBatch,
    onClickCard,
    columnWidth,
    maxHeight = 500,
    // trackSourceType,
    shareUrl,
    viewConfig = {}, // 视图设置
    itemData,
    action,
  } = props
  const [lastRouter] = useState(location.pathname + location.search)
  const { config, dtoConfig } = getPlatformConfig(itemData.platformId, itemData.isFromZkPlatform)
  const dto = itemData?.[dtoConfig?.dto]
  const [visible, setVisible] = useState(false)

  const { collectId, platformId, mainUrl, imageGroupEntityId, inspirationId, loginUserInfo, height, width } = itemData || {}

  const _onChange = (success, newItemData) => {
    if (success) {
      action.onUpdate(newItemData)
      props.onResize?.()
    }
  }

  const auth = loginUserInfo?.inspirationPermissions || []
  const cardHeight = viewConfig.imageType === 'proportionally' ? columnWidth : Math.round((columnWidth * height) / width)

  const titleConfig = TITLE_CONFIG[platformId]

  if (!config) {
    return
  }
  const infoBlock = config[CONFIG_KEY.CARD_INFO_BLOCK] ? config[CONFIG_KEY.CARD_INFO_BLOCK] : config[CONFIG_KEY.INFO_BLOCK] || []

  return (
    <div style={{ width: columnWidth, height: cardHeight, maxHeight }}>
      {isBatch ? (
        <div className={classNames('meinian-waterfall-card-image')}>
          <img
            loading="lazy"
            src={ossImg(mainUrl, 400)}
            style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '9px' }}
          />
          <div className="batch-mask">
            <BatchItem keyValue={`${imageGroupEntityId},${inspirationId}`} className="batch-check" info={itemData} />
          </div>
        </div>
      ) : (
        <div
          className={classNames('meinian-waterfall-card-image')}
          onClick={(e) => {
            if (window.location.pathname.startsWith('/meinian/home/workbench')) {
              util.track('mn-workbench-click', {
                module1: '款式查看',
                module2: props.trackModule2,
                module3: '款式详情',
              })
            }
            history.replaceState(
              {},
              '',
              `/meinian/detail/image?${qs.stringify({
                imageGroupEntityId,
                inspirationId,
                collectId,
                shareUrl,
              })}`
            )
            onClickCard ? onClickCard(itemData, e) : setVisible(true)
          }}
        >
          <img
            referrerPolicy="no-referrer"
            loading="lazy"
            src={ossImg(mainUrl, 400)}
            style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '9px' }}
          />
          <Layer
            showMoveImage={props.showMoveImage}
            childrenFlag={props.childrenFlag}
            allStyleFlag={props.allStyleFlag}
            onDeleteItem={() => {
              action.onDelete([itemData.imageGroupEntityId, itemData.inspirationId])
              props.onResize()
            }}
            onChange={_onChange}
            itemData={itemData}
            hiddenMark={viewConfig.markInfo && columnWidth >= 270}
          >
            {titleConfig
              && dto
              && viewConfig.originalInfo
              && platformId !== PLATFORM_VALUE.INS
              && platformId !== PLATFORM_VALUE.CROSSBORDER_INS && (
                <>
                  {!!infoBlock.length && (
                    <div className="card-num">
                      {infoBlock.map((blockInfo) => (
                        <span>
                          <span className="num">
                            {
                              // eslint-disable-next-line react/jsx-no-useless-fragment
                              Array.isArray(blockInfo.valueKey) ? (
                                <>
                                  {`${hasFromData(blockInfo, dto[blockInfo.valueKey[0]])}/${hasFromData(
                                    blockInfo,
                                    dto[blockInfo.valueKey[1]]
                                  )}`}
                                </>
                              ) : (
                                <>{hasFromData(blockInfo, dto[blockInfo.valueKey])}</>
                              )
                            }
                          </span>
                          <span className="name">{blockInfo.label}</span>
                        </span>
                      ))}
                    </div>
                  )}
                  <div
                    onClick={(e) => {
                      e.stopPropagation()
                      titleConfig.linkUrl && window.open(titleConfig.linkUrl(dto, itemData))
                    }}
                  >
                    <Title title={isFun(titleConfig.title) ? titleConfig.title(dto) : dto[titleConfig.title]} />
                  </div>
                </>
            )}
            {titleConfig
              && dto
              && viewConfig.originalInfo
              && (platformId === PLATFORM_VALUE.INS || platformId === PLATFORM_VALUE.CROSSBORDER_INS) && (
                <Ins dto={dto} infoBlock={infoBlock} itemData={itemData} />
            )}
          </Layer>
          <StyleStateLabel auth={auth} itemData={itemData} viewConfig={viewConfig} />
        </div>
      )}
      {visible ? (
        <ImageDetail
          list={data}
          maxListLength={total || data.length}
          onChangeIndex={props.onChangeIndex}
          visible={visible}
          onChange={_onChange}
          onVisibleChange={(_visible) => {
            history.replaceState({}, '', lastRouter)
            setVisible(_visible)
          }}
          onDeleteItem={(record) => {
            action.onDelete([record.imageGroupEntityId, record.inspirationId])
            props.onResize()
          }}
          initWaterfall={props.initWaterfall}
          initSubColls={props.initSubColls}
        />
      ) : null}
    </div>
  )
}
export default Image

const Ins = ({ dto, infoBlock, itemData }) => {
  const titleConfig = !dto.includedFlag || !dto.bloggerObj ? TITLE_INS_CONFIG[0] : TITLE_INS_CONFIG[1]
  return (
    <>
      {!!infoBlock.length && (
        <div className="card-num">
          {infoBlock.map((blockInfo) => (
            <span>
              <span className="num">{hasFromData(blockInfo, dto[blockInfo.valueKey])}</span>
              <span className="name">{blockInfo.label}</span>
            </span>
          ))}
        </div>
      )}
      <div
        onClick={(e) => {
          e.stopPropagation()
          titleConfig.linkUrl && window.open(titleConfig.linkUrl(dto, itemData))
        }}
      >
        <Title title={isFun(titleConfig.title) ? titleConfig.title(dto) : dto[titleConfig.title]} />
      </div>
    </>
  )
}

const Title = ({ title, style }) => (
  <span className="title" style={style}>
    {title}
  </span>
)
